import { render, staticRenderFns } from "./PointAdjustmentForm.vue?vue&type=template&id=0254f056&scoped=true&"
import script from "./PointAdjustmentForm.vue?vue&type=script&lang=js&"
export * from "./PointAdjustmentForm.vue?vue&type=script&lang=js&"
import style0 from "./PointAdjustmentForm.vue?vue&type=style&index=0&id=0254f056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0254f056",
  null
  
)

export default component.exports